import "./CheckboxBtn.scss";
import React from "react";

export default function CheckboxBtn({ label, itemIndex, isChecked, handleChecked }) {
  function toggleHandler(e) {
    handleChecked(e);
  }

  return (
    <>
      {isChecked ? (
        <button
          type="text"
          size="large"
          onClick={toggleHandler}
          data-id={itemIndex}
          className={`btn btn-checked-${isChecked}`}
        >
          {label}
        </button>
      ) : (
        <button
          type="text"
          size="large"
          onClick={toggleHandler}
          data-id={itemIndex}
          className={`btn btn-checked-${isChecked}`}
        >
          {label}
        </button>
      )}
    </>
  );
}
